
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export const WorksheetLoading: React.FC = () => {
  return (
    <>
      {[...Array(5)].map((_, i) => (
        <TableRow key={`skeleton-${i}`}>
          {[...Array(8)].map((_, j) => (
            <TableCell key={`cell-${i}-${j}`}>
              <Skeleton className="h-8 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
